import { ToastOptions } from 'ng2-toastr';

/**
 * 
 *  created by AHMED HAYEL 
 *
 */

export class CustomOption extends ToastOptions {
  animate = 'flyRight'; // you can override any options available
  newestOnTop = false;
  showCloseButton = true;
  positionClass = 'toast-bottom-right';
  toastLife = 6000;
}


// WEBPACK FOOTER //
// ./src/app/utils/custom.ts